import HeroDouble from '@/components/HeroDouble';
import Hero from '@/components/Hero';
import Header from '@/components/Header';
import SEO from '@/components/SEO';
import { useIsMobile } from '@/hooks/use-mobile';

const Home = () => {
  const isMobile = useIsMobile();

  return (
    <div className="h-screen w-screen overflow-hidden fixed inset-0 touch-none overscroll-none">
      <SEO
        title="Back Page - Freeman & Crown Law"
        description="Protecting your God-given rights through constitutional law, tax law expertise, and legal guidance. Expert constitutional attorneys serving individuals seeking justice."
        image="/lovable-uploads/71fa2df8-9429-454b-a2ba-604271a8b424.png"
        url={window.location.origin + '/back'}
        type="website"
      />
      <Header />
      {isMobile ? <Hero /> : <HeroDouble />}
    </div>
  );
};

export default Home;